import React from 'react';
import { Box, TextField, Button, Typography, FormControl } from '@mui/material';
import { Event } from '../../services/Types';
import { useAllEvents } from '../../hooks/useAllEvents';
import { SelectEventType } from '../../components/SelectEventType/SelectEventType';

interface EditorDetailsProps {
  event: Event;
  setSelectedEvent: (event: Event) => void;
}

export function EditorDetails({ event, setSelectedEvent }: EditorDetailsProps) {

  const handleGoToOverview = () => {
    window.open(`/event/review/${event.id}`, '_blank');
  };

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
      <Typography variant="h6">Event Details</Typography>
      
      <TextField
        label="Title"
        value={event.title || ''}
        onChange={(e) => setSelectedEvent({ ...event, title: e.target.value })}
        fullWidth
      />

      <FormControl fullWidth>
        <SelectEventType
          value={event.eventType || ''}
          onChange={(e) => setSelectedEvent({ ...event, eventType: e })}
        />
      </FormControl>

      <Box sx={{ mt: 2, display: 'flex', justifyContent: 'flex-end' }}>
        <Button 
          variant="contained" 
          onClick={handleGoToOverview}
        >
          Go to Event Overview
        </Button>
      </Box>
    </Box>
  );
} 